import { Component, OnInit } from '@angular/core';
import { WallboardViewService } from '../wallboard-view.service';
import { WVMain } from '../wallboard-view.model';

@Component({
    selector: 'cv-wallboard-view-scorecard',
    templateUrl: './wallboard-view-scorecard.component.html',
    styleUrls: ['./wallboard-view-scorecard.component.scss']
})
export class WallboardViewScorecardComponent implements OnInit {
    public wvf: WVMain;

    constructor(
        private service: WallboardViewService
    ) { }

    ngOnInit(): void {
        this.wvf = this.service.WVMain;
    }
}
